'use client';

import { colors } from '@/theme/zeelool.theme';
import { Rating, styled, SxProps, Theme } from '@mui/material';
import { StarFilled } from '@zeelool/icon';
import React from 'react';

const StyledRating = styled(Rating)({
  '& .MuiRating-iconFilled': {
    color: colors.primaryBlack,
  },
  '& .MuiRating-iconHover': {
    color: '#eff2f7',
  },
  '& .MuiRating-visuallyHidden': {
    color: colors.primaryBlack,
  },
});

export interface StarRatingProps {
  /** 评分值 */
  value?: number;
  /** 是否只读 */
  readOnly?: boolean;
  /** 精度，支持0.5星 */
  precision?: number;
  /** 大小 */
  size?: 'small' | 'medium' | 'large';
  /** 自定义类名 */
  className?: string;
  /** 星星图标大小 */
  iconSize?: string | number;
  /** 星星之间的间距 */
  gap?: string | number;
  /** 自定义样式 */
  sx?: SxProps<Theme>;
  /** 评分改变回调 */
  onChange?: (event: React.SyntheticEvent, newValue: number | null) => void;
  /** 最大评分数量 */
  max?: number;
}

/**
 * 星级评分组件
 * 基于Material-UI Rating组件封装，统一项目中的星级评分样式
 */
export default function StarRating({
  value = 0,
  readOnly = false,
  precision = 0.5,
  size = 'small',
  className = '',
  iconSize = '14px',
  gap = '6px',
  sx,
  onChange,
  max = 5,
}: StarRatingProps) {
  return (
    <StyledRating
      value={value}
      readOnly={readOnly}
      precision={precision}
      size={size}
      max={max}
      className={className}
      icon={<StarFilled fontSize={iconSize} />}
      emptyIcon={<StarFilled fontSize={iconSize} />}
      onChange={onChange}
      sx={{
        '&.MuiRating-root': {
          gap,
        },
        '& .MuiRating-icon': {
          width: iconSize,
          height: iconSize,
        },
        ...sx,
      }}
    />
  );
}
